import { Instagram, Facebook, Twitter } from "@material-ui/icons";
const socialNetworks = [
  {
    value: "facebook",
    label: "Facebook",
    icon: Facebook,
    color: "#1777f2",
  },
  {
    value: "instagram",
    label: "Instagram",
    icon: Instagram,
    color: "#e1306c",
  },
  {
    value: "twitter",
    label: "Twitter",
    icon: Twitter,
    color: "#009ef7",
  },
];
export default socialNetworks;
